<div class="tour-empresa-core-wrapper">

  @if (device === devices.DESKTOP) {
    <app-modal-tour-desktop (onDismissal)="dismiss()" [slides]="data.slidesDesktop"></app-modal-tour-desktop>
  }

  @if (device === devices.MOBILE) {
    <app-modal-tour-mobile (onDismissal)="dismiss()" [slides]="data.slidesMobile"></app-modal-tour-mobile>
  }

</div>